module.exports = __webpack_public_path__ + "static/media/gear.8d650325.svg";